import React, { Component } from "react";
import { Link } from 'react-router-dom';

class Register extends Component {
  render() {
    return (
    <div>
      <section className="breadcrumbs">
          <div className="container">
            <div className="row">
              <div className="col-sm-6 a-breadcrumbs" style={{color: '#ffffff'}}>
                <Link to="/home" className="a-breadcrumbs">หน้าแรก</Link>&nbsp;
                <i className="fa fa-angle-right" />&nbsp;<a href="#" className="a-breadcrumbs">รู้จักสหกรณ์</a>&nbsp;
                <i className="fa fa-angle-right" />&nbsp;<a href="register" className="a-breadcrumbs">สมัครสมาชิก</a>
              </div>
            </div>
          </div>
        </section>
        <section className="page-section">
          <div className="container">
            <div className="row">
              <div className="col-md-9 col-sm-9 mb-sm-50 Infomation-Font" style={{fontFamily: '"Cordia New"'}}>
                <h2 className="title-section mt-0 mb-0"><span>สมัครสมาชิก</span></h2><br/>
                <div className="divider gray left mt-20 mb-25" />
                <p className="mb-20"><u>คุณสมบัติผู้สมัคร</u></p>
                <ul className="mb-25">
                  <li>เป็นผู้เห็นชอบในวัตถุประสงค์ของสหกรณ์นี้</li>
                  <li>เป็นผู้บรรลุนิติภาวะ</li>
                  <li>เป็นหรือเคยเป็นพนักงานประจำในบริษัท ไทยออยล์ จำกัด (มหาชน) และบริษัทในเครือ หรือเป็นเจ้าหน้าที่สหกรณ์ออมทรัพย์ไทยออยล์ จำกัด ซึ่งได้รับการยืนยันให้รับเข้าทำงานแล้ว ผู้ที่เคยเป็นพนักงานประจำในบริษัท ไทยออยล์ จำกัด (มหาชน) และบริษัทในเครือตามวรรคแรกต้องเป็นหรือเคยเป็นสมาชิกของสหกรณ์นี้มาก่อนด้วย</li>
                  <li>มิได้เป็นสมาชิกในสหกรณ์ออมทรัพย์อื่น</li>
                </ul>
                <p className="mb-20">
                  <u>ค่าธรรมเนียมแรกเข้า</u>
                </p>
                <ul className="mb-25">
                  <li>ผู้เข้าเป็นสมาชิกต้องชำระค่าธรรมเนียมแรกเข้าให้แก่สหกรณ์คนละ 10 บาท ค่าธรรมเนียมแรกเข้านี้ให้ถือเป็นรายได้ของสหกรณ์ จะเรียกคืนไม่ได้</li>
                </ul>
                <p className="mb-20"><u>สวัสดิการสมาชิก</u></p>
                <ul className="mb-25">
                  <li>เงินฌาปนกิจสงเคราะห์</li>
                  <li>ของที่ระลึกเนื่องในโอกาสเกษียณอายุ</li>
                  <li>ของที่ระลึกเนื่องในวันคล้ายวันเกิด</li>
                </ul>
                <p className="mb-20"><u>สมาชิกสหกรณ์ได้รับการยกเว้นภาษี</u></p>
                <ul className="mb-25">
                  <li>ในฐานะผู้ถือหุ้น : เงินปันผล เงินเฉลี่ยคืน</li>
                  <li>ในฐานะผู้ฝากเงิน : ดอกเบี้ยเงินฝากออมทรัพย์</li>
                  <li>ในฐานะผู้กู้เงิน :</li>
                  <li>ดอกเบี้ยเงินกู้ยืม-ซื้อบ้าน หักลดหย่อนภาษีเงินได้</li>
                  <li>ยกเว้นอากรแสตมป์สำหรับสัญญากู้เงิน</li>
                  <li>ยกเว้นค่าธรรมเนียมการจดจำนอง</li>
                </ul>
                <p className="mb-20"><u>ขั้นตอนการสมัคร</u></p>
                <ul className="mb-25">
                  <li>ดาวน์โหลดแบบฟอร์มใบสมัคร    <a href="Form\ใบสมัครสมาชิก2569.pdf" target="_blank" style={{color: '#4db6f1'}}>คลิกที่นี่เพื่อดาวน์โหลดใบสมัคร</a></li>
                  <li>กรอกแบบฟอร์มให้ครบถ้วนสมบูรณ์    <a href="Form\ตัวอย่างการกรอกใบสมัครสมาชิก.pdf" target="_blank" style={{color: '#4db6f1'}}>คลิกที่นี่เพื่อดูตัวอย่างการกรอกใบสมัคร</a></li>
                  <li style={{color: 'red'}}>ส่งใบสมัครพร้อมแนบสำเนาบัตรประจำตัวประชาชน, สำเนาทะเบียนบ้าน, สำเนาทะเบียนสมรส(ถ้ามี) และเงินค่าธรรมเนียมแรกเข้า 10 บาท<br />
                    มาที่ คุณสุภาพร  สองหลง (สหกรณ์ออมทรัพย์ไทยออยล์) หรือ ยื่นด้วยตนเองที่เคาน์เตอร์สหกรณ์ อาคารออดิทอเรียม</li>
                  <li>ส่งเอกสารใบสมัครก่อนวันที่ 10 ของทุกเดือน</li>
                  <li>สิทธิในฐานะสมาชิกจะสมบูรณ์ เมื่อ</li>
                  <li>สมาชิกจ่ายค่าหุ้นรายเดือน (สหกรณ์ได้รับเงินค่าหุ้นจากบริษัทต้นสังกัด  ซึ่งหักจากเงินได้รายเดือนตามความประสงค์ของสมาชิก  เพื่อส่งให้สหกรณ์)</li>
                  <li>คณะกรรมการดำเนินการสหกรณ์  มีมติอนุมัติการสมัครเข้าเป็นสมาชิกในการประชุมประจำเดือน</li>
                </ul>
                {/* <a href="RegisterEmployee.aspx" target="_blank" style={{color: '#4db6f1'}}>คลิกที่นี่เพื่อสมัครสมาชิกออนไลน์</a> */}
              </div>
            </div>
          </div>
        </section>
      </div>
      );
  }
}

export default Register;
